import { Link, useLocation } from "react-router-dom";
import PageShell from "@/components/feature/PageShell";
import { useSeo } from "@/hooks/useSeo";

const links = [
  { label: "返回首页", to: "/", icon: "ri-home-4-line", primary: true },
  { label: "动漫资讯", to: "/news", icon: "ri-newspaper-line" },
  { label: "作品库", to: "/works", icon: "ri-film-line" },
  { label: "角色专题", to: "/characters", icon: "ri-user-star-line" },
];

export default function NotFound() {
  const location = useLocation();
  useSeo("页面不存在 - age动漫", "你访问的页面不存在或已被移除，可以返回首页继续浏览动漫资讯、作品与角色分析内容。", "age动漫,404,页面不存在");

  return (
    <PageShell>
      <div className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-24">
        <div className="max-w-2xl mx-auto text-center">
          <p className="font-heading text-6xl md:text-8xl font-extrabold text-primary-500/90">404</p>
          <h1 className="mt-4 text-xl md:text-2xl font-bold text-foreground-950">这个页面好像走丢了</h1>
          <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
            你访问的地址可能已经变更或被移除：
            <span className="block mt-1 text-xs text-foreground-400 break-all">{location.pathname}</span>
          </p>
          <div className="mt-7 flex flex-wrap items-center justify-center gap-2">
            {links.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`inline-flex items-center gap-1.5 px-4 py-2.5 rounded-md text-sm transition-colors cursor-pointer whitespace-nowrap ${
                  link.primary
                    ? "bg-primary-500 text-background-50 font-medium hover:bg-primary-600"
                    : "border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
                }`}
              >
                <i className={link.icon}></i>
                {link.label}
              </Link>
            ))}
          </div>
          <div className="mt-10 rounded-lg border border-background-200 bg-background-100 p-5 text-left">
            <h2 className="text-sm font-semibold text-foreground-900">或者从这些内容开始</h2>
            <p className="mt-2 text-xs text-foreground-500 leading-relaxed">
              首页的焦点轮播整理了近期最值得关注的资讯与作品；分类页支持按标签、类型与年份筛选，也可以直接在顶部搜索框输入关键词查找。
            </p>
          </div>
        </div>
      </div>
    </PageShell>
  );
}